
function getImageURL( img ) {
    return '/assets/img/' + img
}
  
export default getImageURL